import { jsx as _jsx } from "react/jsx-runtime";
import { Button as ChakraButton } from '@chakra-ui/react';
/**
 * A button with a pressed/not pressed state.
 *
 * @see Toggle button role on MDN: https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/button_role#toggle_buttons
 * @see Docs https://bit.cloud/caspeco/casper-ui-library/components/toggle-button
 */
export function ToggleButton({ isPressed = false, children, ...props }) {
    return (_jsx(ChakraButton, { "aria-pressed": isPressed, type: "button", variant: "toggle", ...props, children: children }));
}
//# sourceMappingURL=toggle-button.js.map